import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useControlled } from '../../../../internal/hooks';
/**
 * Хук-контроллер, возвращающий подготовленное состояние
 * и обработчики событий для отдельных частей Tooltip-компонент
 *
 * Этот контроллер реализует поведение открытия/закрытия по клику
 *
 * @export
 * @param {IBaseTooltipProps} props
 * @returns
 */
export function useClickController(props) {
  var children = props.children,
    onClose = props.onClose,
    onOpen = props.onOpen;
  var childrenRef = React.useRef(null);
  var handleChildrenRef = useForkRef(children.ref, childrenRef);
  var _useControlled = useControlled({
      controlled: props.open,
      default: false
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    open = _useControlled2[0],
    setOpen = _useControlled2[1];
  var handleClose = React.useCallback(function () {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);
  var handleClick = function handleClick(e) {
    var childrenProps = children.props;
    if (childrenProps.onClick) {
      childrenProps.onClick(e);
    }
    if (e.defaultPrevented) {
      return;
    }
    e.stopPropagation();
    var nextState = !open;
    setOpen(nextState);
    if (nextState) {
      if (onOpen) {
        onOpen();
      }
    } else {
      if (onClose) {
        onClose();
      }
    }
  };
  var childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onClick: handleClick,
    ref: handleChildrenRef
  });
  return {
    childrenRef: childrenRef,
    childrenProps: childrenProps,
    open: open,
    handleClose: handleClose
  };
}